/**
 * 推广返利管理 - 佣金 API
 *
 * 对应后端: /admin/referral/commissions
 */

import httpRequest from '@/utils/api'
import type { AdminCommissionListData } from '@/types/referral/commission'

enum API {
  commissions = '/admin/referral/commissions',
}

/** 获取佣金记录列表（分页） */
export const getCommissionsAPI = (page: number = 1, pageSize: number = 20) => {
  return httpRequest.get<AdminCommissionListData>({
    url: API.commissions,
    params: { page, page_size: pageSize },
  })
}
